import Button from '@/components/Button';
import CreateLazbubu from '@/components/CreateLazbubu';
import TransitionsModal from '@/components/Modal/modal';
import PageWrapper from '@/components/Page/PageWrapper';
import Row from '@/components/Row';
import { getServerApi } from '@/gql';
import user from '@/stores/user';
import { TYPE } from '@/theme';
import { extractGraphQLErrorMessage, formatHashValue } from '@/utils';
import Alert from '@/utils/components/alert';
import { Check } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const BannerWrapper = styled.div`
    width: 100%;

    background-image: url(${require('@/assets/images/dailyairdrop/background.jpg')});
    background-size: cover;

    background-position: center bottom;

    background-repeat: no-repeat;

    border-radius: 20px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
    height: 400px;
    `};
`;

const StyldePageWrapper = styled(PageWrapper)`
    margin-top: 0;
    padding-bottom: 40px;
    position: relative;
    z-index: 0;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding-top: 20px;
    `};
`;

const StyledRightImg = styled.img`
    position: absolute;
    right: 0;
    bottom: 0;
    width: 500px;
    height: fit-content;
    z-index: -1;
    transform: translateY(100px);

    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 300px;
        transform: translateY(50px);
    `};
`;

const TextWrapper = styled.div`
    width: 100%;
    height: 100%;

    padding: 20px;
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    margin: 0 auto;
`;

const RefreshedDesc = styled.div`
    width: 100%;
    height: 44px;
    background-color: #fff;
    color: #000;
    border-radius: 10px;
    border: none;
    font-size: 16px;
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 0 16px;
`;

const ClaimedDesc = styled.div`
    width: 100%;
    height: 60px;
    background-color: #000;
    color: #fff;
    border-radius: 10px;
    border: none;
    font-size: 16px;
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
    height: 48px;
    `};
`;

const EligibilityWrapper = styled.div`
    max-width: 1200px;
    margin: 60px auto;
    padding: 40px;
    background: #ffffff8f;
    border-radius: 20px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        margin: 10px auto;
        padding: 20px;
    `};
`;

const EligibilityTitle = styled.h1`
    font-size: 48px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #000;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 24px;
        margin-bottom: 20px;
    `};
`;

const StepsContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        grid-template-columns: 1fr;
        gap: 40px;
    `};
`;

const StepWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: #fff;
    padding: 40px;
    border-radius: 20px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 20px;
       
    `};
`;

const StepContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
`;

const StepButtonWrapper = styled.div`
    margin-top: auto;
    padding-top: 20px;
`;

const StepTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #000;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 18px;
        margin-bottom: 8px;
    `};
`;

const StepDescription = styled.p`
    font-size: 16px;
    color: #666;
    margin-bottom: 20px;
    line-height: 1.5;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 14px;
        margin-bottom: 12px;
    `};
`;

const BalanceCard = styled.div`
    background-color: #f5f5f5;
    border-radius: 16px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 16px;
        gap: 16px;
    `};
`;

const ConnectedInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #666;
    flex-wrap: wrap;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 12px;
    `};
`;

const WalletAddress = styled.span`
    color: #3563f3;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;

const ChainIcons = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

const ChainIcon = styled.img<{ $active?: boolean }>`
    width: 28px;
    height: 28px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    border: ${({ $active }) => ($active ? '2px solid #3563F3' : 'none')};
    transition: all 0.2s ease-in-out;
    ${({ $active }) =>
        $active &&
        `
        transform: scale(1.1);
        box-shadow: 0 0 8px rgba(53, 99, 243, 0.4);
    `}
`;

const CHAIN_LIST = [
    {
        id: 'ethereum',
        chainIds: [1],
        icon: require('@/assets/images/network/ethereum.png'),
    },
    {
        id: 'bnb',
        chainIds: [56],
        icon: require('@/assets/images/network/binance.png'),
    },
    {
        id: 'metis',
        chainIds: [1088, 59902],
        icon: require('@/assets/images/network/metis.png'),
    },
    {
        id: 'base',
        chainIds: [8453],
        icon: require('@/assets/images/network/base.png'),
    },
    {
        id: 'optimism',
        chainIds: [10],
        icon: require('@/assets/images/network/optimism.svg'),
    },
    {
        id: 'aave',
        chainIds: [], // TODO: Confirm Chain ID for Aave
        icon: require('@/assets/images/network/aave.png'),
    },
];

const BalanceInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const BalanceText = styled.span`
    font-size: 14px;
    color: #8f8f8f;
    font-weight: 500;
    background-color: #ebeffe;
    padding: 8px;
    border-radius: 10px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 14px;
    `};
`;

const CheckIcon = styled(CheckCircleIcon)`
    color: #4caf50;
    font-size: 32px;
`;

const ClaimButton = styled(Button)`
    width: 100%;
    height: 64px;
    border-radius: 16px;
    font-size: 18px;
    font-weight: 600;
    border: none;

    transition: all 0.2s;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        height: 56px;
        font-size: 16px;
    `};
`;

const ClaimDescription = styled.p`
    font-size: 16px;
    color: #666;
    text-align: left;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 14px;
    `};
`;

const SuccessModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    gap: 30px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 30px 16px;
        gap: 24px;
    `};
`;

const SuccessIcon = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #4caf50;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        color: #fff;
        font-size: 48px;
    }

    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 64px;
        height: 64px;

        svg {
            font-size: 36px;
        }
    `};
`;

const SuccessTitle = styled.h2`
    font-size: 24px;
    font-weight: 600;
    color: #000;
    margin: 0;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 20px;
    `};
`;

const MintButton = styled.button`
    width: 100%;
    max-width: 300px;
    height: 56px;
    border-radius: 12px;
    background-color: #3563f3;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background-color: #2451d1;
    }

    ${({ theme }) => theme.mediaWidth.upToSmall`
        height: 48px;
        font-size: 14px;
    `};
`;

const MintModalContent = styled.div`
    width: 600px;
    max-width: 500px;
    max-height: 90vh;
    overflow-y: auto;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: calc(100vw - 4rem);
    `};
`;

const StyledRow = styled(Row)`
    justify-content: space-between;

    ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
    gap: 20px;
    `};
`;

type ClaimStatus = 'not-eligible' | 'claim' | 'claimed';

function LazbubuDailyAirdrop() {
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isMintModalOpen, setIsMintModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [claimedCount, setClaimedCount] = useState<number>(0);
    const [airdropLazbubuData, setAirdropLazbubuData] = useState<string>('');
    const [airdropLazbubuCreated, setAirdropLazbubuCreated] =
        useState<boolean>(false);
    const [maxUsdAsset, setMaxUsdAsset] = useState<any>(null); // TODO: Replace any with generated type if available

    const walletAddress = formatHashValue(user.address);
    const isEligible = !!maxUsdAsset && maxUsdAsset.usd_value >= 1000;
    const hasClaimed = !!airdropLazbubuCreated;
    const history = useHistory();

    const fetchAirdropInfo = async () => {
        try {
            const infoRes = await getServerApi().airdropInfo();
            setAirdropLazbubuCreated(!!infoRes.airdropLazbubuCreated);
            if (infoRes.airdropLazbubuData) {
                setAirdropLazbubuData(infoRes.airdropLazbubuData);
            }
            return infoRes;
        } catch (error) {
            console.error('Failed to fetch airdrop info:', error);
            throw error; // Rethrow to let caller handle it
        }
    };

    const fetchCountTodayAirdrop = async () => {
        try {
            const result = await getServerApi().countTodayAirdrop();
            setClaimedCount(result.countTodayAirdrop);
        } catch (error) {
            console.error('Failed to fetch countTodayAirdrop:', error);
        }
    };

    // Fetch initial data
    useEffect(() => {
        const fetchInitialData = async () => {
            if (!user?.userDetail?.id) {
                setMaxUsdAsset(0);
            }

            try {
                const assetRes = await getServerApi().maxUsdAsset();
                setMaxUsdAsset(assetRes.maxUsdAsset || 0);
            } catch (error) {
                console.error('Failed to fetch maxUsdAsset:', error);
            }

            try {
                await fetchAirdropInfo();
            } catch (error) {
                // Initial fetch error can be just logged or handled silently
                console.error('Initial airdrop info fetch failed', error);
            }
        };
        fetchInitialData();
    }, [user.userDetail?.id]);

    // Poll countTodayAirdrop every minute
    useEffect(() => {
        // Fetch immediately
        fetchCountTodayAirdrop();

        // Set up polling every minute (60000ms)
        const interval = setInterval(() => {
            fetchCountTodayAirdrop();
        }, 60000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const handleCheckEligible = async () => {
        setIsLoading(true);
        try {
            await fetchAirdropInfo();
        } catch (error) {
            console.error('Failed to check eligibility:', error);
            const errorMessage = extractGraphQLErrorMessage(error);
            Alert({
                type: 'error',
                text: errorMessage,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleClaim = async () => {
        setIsMintModalOpen(true);
        // setIsSuccessModalOpen(true);
        // Update claimed count potentially
        try {
            await fetchCountTodayAirdrop();
            // Also refresh claimed status
            await fetchAirdropInfo();
        } catch (error) {
            console.error('Failed to update status:', error);
        }
    };

    const handleRefetchLazbubuData = async () => {
        try {
            await fetchAirdropInfo();
        } catch (error) {
            console.error('Failed to refetch lazbubu data:', error);
        }
    };

    return (
        <>
            <BannerWrapper>
                <StyldePageWrapper>
                    <TextWrapper>
                        <TYPE.main fontSize={48} mobileFz={20} color="#3563F3">
                            Lazbubu
                        </TYPE.main>
                        <TYPE.main
                            fontSize={72}
                            fontWeight={600}
                            mobileFz={36}
                            style={{ position: 'relative' }}
                        >
                            Daily Box Drop
                        </TYPE.main>
                        <TYPE.main fontSize={16} mobileFz={14}>
                            Daily limited giveaway for qualified users — only
                            1,000 boxes per day, first come, first served.
                        </TYPE.main>
                        <RefreshedDesc>
                            Distribution refreshes at 00:00 UTC
                        </RefreshedDesc>
                        <ClaimedDesc>
                            <TYPE.main fontSize={16} mobileFz={14} color="#fff">
                                Claimed:
                            </TYPE.main>
                            <TYPE.main
                                fontSize={24}
                                mobileFz={14}
                                color="#fff"
                                fontWeight={600}
                            >
                                {claimedCount} / 1000
                            </TYPE.main>
                        </ClaimedDesc>
                    </TextWrapper>
                    <StyledRightImg
                        src={require('@/assets/images/dailyairdrop/banner.png')}
                    />
                </StyldePageWrapper>
            </BannerWrapper>

            <PageWrapper>
                <EligibilityWrapper>
                    <EligibilityTitle>Check your eligibility</EligibilityTitle>

                    <StepsContainer>
                        {/* Step 1: Verify Balance */}
                        <StepWrapper>
                            <StepContent>
                                <StepTitle>Step 1:</StepTitle>
                                <StepDescription>
                                    Verify your balance
                                </StepDescription>
                                <TYPE.main
                                    fontSize={14}
                                    mobileFz={12}
                                    color="#666"
                                >
                                    Your wallet balance must be ≥ 1,000 USDT on
                                    Ethereum/BNB Chain/ Metis
                                    Andromeda/Base/Optimism/Aave
                                </TYPE.main>

                                <BalanceCard>
                                    <ConnectedInfo>
                                        Connected as{' '}
                                        <WalletAddress>
                                            {walletAddress}
                                        </WalletAddress>
                                    </ConnectedInfo>

                                    <StyledRow>
                                        <ChainIcons>
                                            {CHAIN_LIST.map((chain) => {
                                                const isActive =
                                                    maxUsdAsset &&
                                                    chain.chainIds.includes(
                                                        maxUsdAsset.community_id,
                                                    );
                                                return (
                                                    <ChainIcon
                                                        key={chain.id}
                                                        src={chain.icon}
                                                        $active={!!isActive}
                                                    />
                                                );
                                            })}
                                        </ChainIcons>

                                        <BalanceInfo>
                                            <BalanceText>
                                                Balance: $
                                                {maxUsdAsset?.usd_value?.toFixed(
                                                    0,
                                                ) || '0.00'}
                                            </BalanceText>
                                            {isEligible && <CheckIcon />}
                                        </BalanceInfo>
                                    </StyledRow>
                                </BalanceCard>
                            </StepContent>
                        </StepWrapper>

                        {/* Step 2: Claim Box */}
                        <StepWrapper>
                            <StepContent>
                                <StepTitle>Step 2:</StepTitle>
                                <StepDescription>
                                    Claim your box
                                </StepDescription>
                                <ClaimDescription>
                                    You can claim if you don't already have a
                                    blind box.
                                </ClaimDescription>
                            </StepContent>

                            <StepButtonWrapper>
                                {hasClaimed ? (
                                    <ClaimButton auth disabled>
                                        You have claimed
                                    </ClaimButton>
                                ) : !isEligible ? (
                                    <ClaimButton auth disabled>
                                        Not eligible
                                    </ClaimButton>
                                ) : !airdropLazbubuData ? (
                                    <ClaimButton
                                        auth
                                        onClick={handleCheckEligible}
                                        disabled={isLoading}
                                    >
                                        {isLoading
                                            ? 'Checking...'
                                            : 'Check eligible'}
                                    </ClaimButton>
                                ) : (
                                    <ClaimButton
                                        auth
                                        onClick={handleClaim}
                                        disabled={isLoading}
                                    >
                                        Claim box
                                    </ClaimButton>
                                )}
                            </StepButtonWrapper>
                        </StepWrapper>
                    </StepsContainer>
                </EligibilityWrapper>
            </PageWrapper>

            {/* Success Modal */}
            <TransitionsModal
                isOpen={isSuccessModalOpen}
                onClose={() => setIsSuccessModalOpen(false)}
                hideClose={false}
            >
                <SuccessModalContent>
                    <SuccessIcon>
                        <Check />
                    </SuccessIcon>
                    <SuccessTitle>You've got your free lazbubu!</SuccessTitle>
                    <MintButton
                        onClick={() => {
                            history.push('/my');
                        }}
                    >
                        Go to my Lazbubu
                    </MintButton>
                </SuccessModalContent>
            </TransitionsModal>

            {/* Mint Modal */}
            <TransitionsModal
                isOpen={isMintModalOpen}
                onClose={() => setIsMintModalOpen(false)}
                hideClose={false}
            >
                <MintModalContent>
                    <CreateLazbubu
                        lazbubuData={airdropLazbubuData}
                        refetchLazbubuData={handleRefetchLazbubuData}
                        onCreateSuccess={() => {
                            setIsMintModalOpen(false);
                            setIsSuccessModalOpen(true);
                            // Refresh claimed status
                            // handleRefetchLazbubuData();
                            setAirdropLazbubuCreated(true);
                        }}
                    />
                </MintModalContent>
            </TransitionsModal>
        </>
    );
}

export default observer(LazbubuDailyAirdrop);
